import(/* webpackMode: "eager" */ "/home/runner/work/ark/ark/@apps/web/src/app/[locale]/error.tsx");
